module.exports = __webpack_public_path__ + "static/media/ambudog.4e0cc660.png";